/**
 * HeaderBackButton Styles
 */

import { StyleSheet } from 'react-native';

export const headerBackButtonStyles = StyleSheet.create({
  button: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonPressed: {
    opacity: 0.7,
  },
  buttonHover: {
    opacity: 0.85,
  },
});
